import { Middlewares } from "@/app/shared/services/app-router/middlewares";
import Guard from "vue-router-multiguard";

export default [
  {
    path: '/registration-step1',
    name: 'RegistrationStep1',
    component: () => import('./views/page1.vue'),
    meta: {
      title: 'Регистрация',
      wfPage: '652921c910bae02d8870dddd'
    }
  },
  {
    path: '/registration-step4',
    name: 'RegistrationStep4',
    component: () => import('./views/page4.vue'),
    meta: {
      title: 'Регистрация',
      wfPage: '6666f36e81c9970423fa5480'
    }
  }
  ];
